import * as React from 'react';
import { IEvent } from './EventsWidget';

export default function EventEventItem(
  event: IEvent,
  index: number,
  isInTooltip: boolean
): JSX.Element {
  return (
    <li
      style={{ marginTop: '4px', width: '100%' }}
      key={`${event.type}-${index}`}
      title={event.title}
    >
      <i
        style={{ color: isInTooltip ? '#78E5CE' : '#128169', marginRight: '7px' }}
        className="cmd-icon cmd-icon-event"
      />
      <span
        // className={`${!isInTooltip ? 'text-truncate' : ''}`}
        className="text-truncate"
        style={{
          width: '250px',
          verticalAlign: 'middle',
          whiteSpace: 'nowrap',
          display: 'inline-block',
          lineHeight: 'normal',
        }}
      >
        {event.title}
      </span>
    </li>
  );
}
